import { useState } from 'react'
import { signInWithGoogle } from './auth'

export function LoginPage() {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function onSignIn() {
    setBusy(true)
    setError(null)
    try {
      await signInWithGoogle()
      // The browser navigates away to Google; if it returns, an error occurred.
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e))
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-slate-950 px-6 text-center text-slate-100">
      <div>
        <h1 className="text-2xl font-semibold">Mobile Trading Pro</h1>
        <p className="mt-1 text-sm text-slate-400">
          Offline ledger for your mobile shop. Sign in to sync and back up your records.
        </p>
      </div>

      <button
        type="button"
        onClick={() => void onSignIn()}
        disabled={busy}
        className="w-full max-w-xs rounded-xl bg-sky-500 px-4 py-3 text-base font-semibold text-white disabled:opacity-60"
      >
        {busy ? 'Redirecting…' : 'Sign in with Google'}
      </button>

      {error ? (
        <p role="alert" className="max-w-xs text-sm text-rose-400">
          {error}
        </p>
      ) : null}

      <p className="max-w-xs text-xs text-slate-500">
        One owner, one private workspace. Your data is isolated by row-level security.
      </p>
    </div>
  )
}
